<div class="table-container">
    <table mat-table class="generic-table-wrapper mat-table cdk-table"
        *ngIf="tableConfig?.tableDataSource?.data?.length" #table [dataSource]="tableConfig.tableDataSource" matSort
        multiTemplateDataRows matSortDisableClear [hiddenColumns]="[8]" (matSortChange)="sortData($event)" cdkDropList
        cdkDropListOrientation="horizontal" (cdkDropListDropped)="onColumnDrop($event)">

        <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.columnName">

            <!-- if sortable column header -->
            <ng-container *ngIf="tableColumn.isSortable; else notSortable">
                <th mat-header-cell *matHeaderCellDef [mat-sort-header]="tableColumn.dataKey" cdkDrag
                    [cdkDragDisabled]="!tableColumn?.isDraggable">
                    <span
                        [ngStyle]="{'visibility': tableColumn?.showHeader ? 'visible' : 'hidden'}">{{tableColumn?.columnName
                        | titlecase}}</span>
                </th>
            </ng-container>

            <!-- else not sortable -->
            <ng-template #notSortable>
                <th mat-header-cell *matHeaderCellDef [cdkDrag]="tableColumn?.isDraggable  ?? false">
                    <span
                        [ngStyle]="{'visibility': tableColumn?.showHeader ? 'visible' : 'hidden'}">{{tableColumn?.columnName
                        | titlecase}}</span>
                </th>
            </ng-template>

            <td mat-cell class="cell" [ngClass]="tableColumn?.customClass" *matCellDef="let element; let i = dataIndex;"
                (mouseover)="onRowHover(i)" (mouseleave)="onRowLeave()">
                <div class="d-flex align-items-center">
                    <!-- To show serial number for rows -->
                    <span *ngIf="tableColumn.type == 'indexed'">
                        {{ page * limit + i + 1 }}.
                    </span>


                    <!-- To show a list of users in terms of avathar -->
                    <span *ngIf="tableColumn.isArray && tableColumn.type =='user'" class="d-flex">
                        <div style="margin-left:-12px;"
                            *ngFor="let user of getNestedValue(element, tableColumn.dataKey, tableColumn) | slice:0:4; let i=index"
                            [ngStyle]="{'z-index': 100 - i}">
                            <ngx-avatars [name]="user" size="30" class="avathar"
                                [matTooltip]="tableColumn?.getTooltipText(user)"></ngx-avatars>
                        </div>
                        <div style="margin-left:-12px;"
                            *ngIf="getRemainingUserCount(element, tableColumn.dataKey , tableColumn, 'count') > 0"
                            [ngStyle]="{'z-index': 100 - 4}">
                            <ngx-avatars name="+" size="30" class="avathar remaining-avathar"
                                [matTooltip]="getRemainingUserCount(element, tableColumn.dataKey , tableColumn, 'tooltipText')"></ngx-avatars>
                        </div>
                        <span *ngIf="!getNestedValue(element, tableColumn.dataKey,tableColumn).length">-</span>
                    </span>

                    <!-- To show date column-->
                    <span *ngIf="tableColumn.type == 'date'">{{getNestedValue(element, tableColumn.dataKey) | date
                        :'mediumDate'}}</span>

                    <!-- To show icons prefixed-->
                    <span class="image"
                        *ngIf="tableColumn.imageConfig && tableColumn.imageConfig.imagePosition == 'before'">
                        <ng-container *ngTemplateOutlet="tableColumn?.imageConfig.imageElement"></ng-container>
                    </span>

                    <!--To render editable content-->
                    <span *ngIf="tableColumn.type == 'editable-content'" style="cursor:pointer;">
                        <span *ngIf="getIsReadOnly(tableColumn, i)"
                            (click)="handleClickOnInputElement(tableColumn,i,element)">{{getNestedValue(element,
                            tableColumn.dataKey)
                            ?? '-'}}
                        </span>
                        <input class="input-element" #input style="cursor: pointer;" type="text"
                            *ngIf="!getIsReadOnly(tableColumn, i)" [readOnly]="getIsReadOnly(tableColumn, i)"
                            [value]="getNestedValue(element, tableColumn.dataKey)" [id]='i + (this.page * this.limit)'
                            tabindex="-1" autofocus (change)="handleChange($event)"
                            (blur)="handleEdit($event, element, tableColumn)"
                            [ngClass]="{ 'hovered-input': shouldChangeBackgroundOnHover }" />
                    </span>

                    <!--To just show normal content and also this can emit click event to parent-->
                    <span *ngIf="!tableColumn.type" (click)="tableColumn?.onClick(element)" style="cursor:pointer;">
                        {{getNestedValue(element, tableColumn.dataKey) ?? '-'}}
                    </span>

                    <!-- To show a div element-->
                    <span *ngIf="tableColumn.type == 'htmlDivElement'" (click)="tableColumn?.onClick(element)">
                        <ng-container *ngTemplateOutlet="tableColumn?.divElement"></ng-container>
                    </span>

                    <!--To show suffixed icon-->
                    <div class="image"
                        *ngIf="tableColumn.imageConfig && tableColumn.imageConfig.imagePosition == 'after'">
                        <ng-container *ngTemplateOutlet="tableColumn?.imageConfig.imageElement"></ng-container>
                    </div>

                    <!--when you hover a particular row and if you have to show some content on a column-->
                    <div class="hovered-class"
                        [ngClass]="{ 'hovered-content-class': (tableColumn?.contentToShowOnHover && (this.page * this.limit) + i == hoveredRowIndex && tableColumn?.isReadOnly)}">
                        <ng-container *ngTemplateOutlet="tableColumn?.contentToShowOnHover"></ng-container>
                    </div>

                    <!-- To just show a single user -->
                    <div *ngIf="tableColumn.type =='user' && !tableColumn.isArray " class="d-flex">
                        <ngx-avatars [name]="getNestedValue(element, tableColumn.dataKey)" size="30" class="avathar"
                            [matTooltip]="tableColumn?.getTooltipText(getNestedValue(element, tableColumn.dataKey))"></ngx-avatars>
                        <span *ngIf="!getNestedValue(element, tableColumn.dataKey)">-</span>
                    </div>

                    <!--To show forms-->
                    <span *ngIf="tableColumn.type == 'form'">
                        <mat-form-field *ngIf="tableColumn.formfieldConfig.type == 'dropdown'">
                            <mat-select disableOptionCentering="true"
                                [disabled]="tableColumn.formfieldConfig.fieldDisabled"
                                [placeholder]="tableColumn.formfieldConfig.placeholder??''"
                                [value]="tableColumn.formfieldConfig.value"
                                (selectionChange)="onDropdownOptionSelect(tableColumn,$event,element)">
                                <mat-option *ngFor="let option of tableColumn.formfieldConfig.dropdownOptions"
                                    [value]="option.id" [disabled]="option.disabled"
                                    [matTooltip]="option.label">{{option.label}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-checkbox *ngIf="tableColumn.formfieldConfig.type == 'checkbox'"
                            (click)="handleCheckboxClick(tableColumn,$event,element)"
                            [checked]="tabeColumn.formfieldConfig.checboxConfig.checked"
                            [disabled]="tableColumn.formfieldConfig?.checboxConfig.disabled"></mat-checkbox>
                    </span>
                </div>
            </td>
        </ng-container>

        <!--if you have to add different rows in a table-->
        <ng-container matColumnDef="addRow" stickyEnd="true" *ngIf="showAddColumn">
            <th class="add-btn-container" mat-header-cell *matHeaderCellDef #addColumnButton style="width:0px">
                <button class="add-button" matTooltip="Add Column" mat-button *ngIf="!isColumnDragged"
                    (click)="openColumnMenu()"><mat-icon>add</mat-icon></button>
                <button mat-raised-button [disabled]="isColumnDragged && showLoader" class="apply-button"
                    color="primary" *ngIf="isColumnDragged" (click)="handleColumnDrag()" matTooltip="Save View">
                    <div *ngIf="showLoader"
                        [ngClass]="{'kt-spinner loader kt-spinner--center kt-spinner--sm kt-spinner--light kt-us-spinner': showLoader}">
                    </div>
                    <i class="flaticon2-checkmark" *ngIf="!showLoader"></i>
                </button>
            </th>
            <td mat-cell *matCellDef="let alert" class="addIcon"></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns" [ngStyle]="tableConfig?.headerRowStyles"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

    <div *ngIf="isTableLoading" class="d-flex justify-content-center align-items-center"
        [ngClass]="{'kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--dark kt-us-spinner': !isTableLoading}">
        <b class="select-placeholder-container ">Loading...</b>
    </div>
    <div class="mat-table__message d-flex justify-content-center align-items-center" *ngIf="!tableConfig.tableDataSource?.data?.length && !isTableLoading">
        <kt-empty-state *ngIf="emptyStateConfig; else plainNoRecords" [heading]="emptyStateConfig.heading | translate"
            [content]="emptyStateConfig.content | translate"
            [fileIcon]="{ src: 'assets/media/alerts-2.0/page-not-found.svg', alt: 'No DashBoards yet' }">
        </kt-empty-state>
        <ng-template #plainNoRecords>
            <div class="mat-table__message d-flex justify-content-center align-items-center">
                No records found
            </div>
        </ng-template>
    </div>

    <!-- Pagination -->
    <mat-paginator #paginator [pageSizeOptions]="pageSizeOptions" [length]="tableConfig?.tableDataSource?.data?.length"
        [pageSize]="limit" [pageIndex]="page" (page)="onPageChange($event)">
    </mat-paginator>
</div>

<div class="column-details-container" *ngIf="isMenuOpen" #menuTrigger>
    <div class="kt-portlet portlet-container" [style.marginBottom]="'unset'" (click)="$event.stopPropagation()">
        <div class="kt-form">
            <div cdkDragHandle class="kt-portlet__head kt-portlet__head__custom header-container">
                <div class="kt-portlet__head-label">
                    <h3 class="kt-portlet__head-title">Select Columns</h3>
                </div>
            </div>
            <div cdkDragHandle class="kt-portlet__body portlet-body-container">
                <div class="column-options-container">
                    <div class="column-name-container" *ngFor="let columnName of additionalColumns"
                        (click)="handleColumnSelect(columnName)">
                        <mat-checkbox name="subtype" class="checkbox-container"
                            [checked]="isOptionSelected(columnName.columnName)" (click)="$event.preventDefault();">
                            {{columnName.columnName}}</mat-checkbox>
                    </div>
                </div>
            </div>
            <div class="kt-portlet__foot  text-right">
                <div class="p-2 !important d-flex justify-content-end kt-form__actions">
                    <button mat-raised-button color="primary" cdkFocusInitial [disabled]="isApplyButtonDisabled()"
                        (click)="onApply()" class="apply-button">
                        <div *ngIf="showLoader"
                            [ngClass]="{'kt-spinner loader kt-spinner--center kt-spinner--sm kt-spinner--light kt-us-spinner': showLoader}">
                        </div>
                        <div *ngIf="!showLoader">Apply</div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>